import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { strings } from "@/i18n";

const links = [
  { to: "/", key: "accueil", testId: "menu-link-accueil" },
  { to: "/notre-histoire", key: "histoire", testId: "menu-link-histoire" },
  { to: "/70ans", key: "livret", testId: "menu-link-livret" },
  { to: "/la-boutique", key: "boutique", testId: "menu-link-boutique" },
  { to: "/livre-d-or", key: "livreOr", testId: "menu-link-livre-or" },
  { to: "/photos-videos", key: "photos", testId: "menu-link-photos" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { lang, setLang } = useLanguage();
  const s = strings.nav[lang];

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-40 border-b border-bordeaux/15 bg-ivory/95 backdrop-blur-sm" data-testid="navbar">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 md:px-8">
        <Link
          to="/"
          data-testid="nav-logo-roganel"
          className="font-serif text-xl md:text-2xl font-medium tracking-[0.35em] text-bordeaux transition-opacity duration-300 hover:opacity-70"
        >
          ROGANEL
        </Link>
        <div className="flex items-center gap-4 md:gap-6">
          <div className="flex items-center gap-2 font-sans text-[11px] font-medium tracking-[0.2em]" data-testid="lang-selector">
            <button
              type="button"
              onClick={() => setLang("fr")}
              data-testid="lang-fr-button"
              className={`transition-colors duration-300 ${lang === "fr" ? "text-bordeaux" : "text-noir/35 hover:text-bordeaux"}`}
            >
              FR
            </button>
            <span className="text-bordeaux/30">|</span>
            <button
              type="button"
              onClick={() => setLang("en")}
              data-testid="lang-en-button"
              className={`transition-colors duration-300 ${lang === "en" ? "text-bordeaux" : "text-noir/35 hover:text-bordeaux"}`}
            >
              EN
            </button>
          </div>
          <button
            type="button"
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            data-testid="menu-toggle-button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex items-center gap-2.5 border border-bordeaux px-4 py-2.5 font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-bordeaux transition-[background-color,color] duration-300 hover:bg-bordeaux hover:text-ivory md:px-6 md:py-3"
          >
            {open ? <X size={16} strokeWidth={1.5} /> : <Menu size={16} strokeWidth={1.5} />}
            {s.menu}
          </button>
        </div>
      </div>

      {open && (
        <div className="absolute inset-x-0 top-full z-50 border-b border-bordeaux/20 bg-ivory shadow-[0_30px_45px_-30px_rgba(92,11,19,0.4)]" data-testid="menu-dropdown">
          <nav className="mx-auto max-w-6xl px-6 py-4 md:px-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testId}
                className={({ isActive }) =>
                  `flex items-center gap-4 border-b border-bordeaux/10 py-4 font-sans text-sm font-medium uppercase tracking-[0.3em] transition-colors duration-300 last:border-b-0 md:py-5 ${
                    isActive ? "text-bordeaux" : "text-noir/70 hover:text-bordeaux"
                  }`
                }
              >
                <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-bordeaux" aria-hidden="true" />
                {s[l.key]}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
